import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import GetAppIcon from '@mui/icons-material/GetApp';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import AxiosConfig from '../../../../config/AxiosConfig';
import { ErrorPopup } from '../errors/AlertPopup.jsx';

const ExtractRefundButton = () => {
  const [extractedAt, setExtractedAt] = useState('');
  const [monthMode, setMonthMode] = useState(true);
  const [errState, setErrState] = useState(false);

  // Obtenir la date actuelle
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const changeMode = (event) => {
    setMonthMode(event.target.value === 'month');
    setExtractedAt('');
  };

  const handleDateChange = (event) => {
    setExtractedAt(event.target.value);
  };

  const exportToExcel = async (date) => {
    if (!date) {
      setErrState(true);
      return;
    }
    const APIurl = monthMode
      ? `/refundextracts/${date}/getMonth`
      : `/refundextracts/${date}/getYear`;
    const filename = monthMode
      ? `${date.split('-')[1]}-${date.split('-')[0]}-refunds.xlsx`
      : `${date}-refunds.xlsx`;

    await AxiosConfig.create('get', APIurl)
      .call()
      .exit((res) => {
        if (res?.data?.length === 0) {
          setErrState(true);
          return;
        }
        const worksheet = XLSX.utils.json_to_sheet(res?.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/octet-stream',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', filename);
        a.click();
      })
      .catch(() => setErrState(true));
  };

  const isDateValid = () => {
    if (monthMode) {
      return extractedAt && extractedAt.includes('-');
    } else {
      return extractedAt && extractedAt.length === 4;
    }
  };

  return (
    <>
      <ErrorPopup
        message="Pas de demandes de remboursement trouvées pour cette date"
        open={errState}
        setOpen={setErrState}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 2,
          marginRight: 2,
          padding: 2,
        }}
      >
        <Stack direction="column" spacing={1} alignItems="center">
          <RadioGroup
            aria-label="Mode de sélection"
            defaultValue="month"
            name="radio-buttons-group"
            value={monthMode ? 'month' : 'year'}
            onChange={changeMode}
          >
            <FormControlLabel value="month" control={<Radio />} label="Mois" />
            <FormControlLabel value="year" control={<Radio />} label="Année" />
          </RadioGroup>
        </Stack>

        <FormControl variant="standard">
          {monthMode ? (
            <TextField
              label=""
              type="month"
              value={extractedAt}
              onChange={handleDateChange}
              variant="outlined"
              size="small"
              sx={{
                width: 'auto',
                minWidth: '120px',
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarTodayIcon fontSize="medium" />
                    </InputAdornment>
                  ),
                  inputProps: {
                    min: '2019-01',
                    max: `${currentYear}-${String(currentMonth).padStart(
                      2,
                      '0'
                    )}`,
                  },
                },

                inputLabel: {
                  shrink: true,
                },
              }}
            />
          ) : (
            <TextField
              label=""
              type="number"
              value={extractedAt}
              onChange={handleDateChange}
              variant="outlined"
              size="small"
              sx={{
                width: 'auto',
                minWidth: '120px',
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarTodayIcon fontSize="medium" />
                    </InputAdornment>
                  ),
                  inputProps: { min: 2019, max: currentYear },
                },
              }}
            />
          )}
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          size="medium" // Changer la taille du bouton
          onClick={() => exportToExcel(extractedAt)}
          startIcon={<GetAppIcon fontSize="small" />} // Agrandir l'icône
          disabled={!isDateValid()}
          sx={{
            padding: '10px 20px',
            minWidth: '120px',
            textTransform: 'none',
            transition: 'background-color 0.3s', // Effet de transition
            '&:hover': {
              backgroundColor: '#1976d2', // Couleur au survol
            },
          }}
        >
          Exporter
        </Button>
      </Box>
    </>
  );
};

export default ExtractRefundButton;
